module.exports = __webpack_public_path__ + "img/poll-answer.0172c605.png";